import {mapValues, padStart} from 'vendor';

export function time(value: string) {
  const match = /(\d+):(\d{2}) (AM|PM)/.exec(value);
  if (match) {
    const [hours, minutes, daytime] = match.slice(1);
    return {
      daytime,
      hours,
      hoursWithDaytime: hours + ' ' + daytime,
      minutes,
      valid: true
    };
  }

  const [, hours, minutes, daytime] = /([\w\d]+):([\w\d]+) ([\w\d]+)/.exec(value) ?? [];
  return mapValues({
    daytime,
    hours,
    hoursWithDaytime: hours ? (hours + ' ' + daytime) : undefined,
    minutes,
    valid: false
  }, sanitize);
}

export function secondsToTime(value: number | string) {
  if (typeof value === 'string') {
    value = parseInt(value ?? '0');
  } else if (typeof value !== 'number') {
    return {};
  }
  const seconds = Math.max(value, 0);
  const minutes = Math.floor(seconds / 60) % 60;
  const hours = Math.floor(seconds / 60 / 60);
  return {
    hours,
    minutes,
    seconds: seconds % 60,
    string: `${hours}:${padStart(minutes.toString(), 2, '0')}`,
    valid: true
  };
}

function sanitize(value: any) {
  return value === 'undefined' ? undefined : value;
}
